// extracted by mini-css-extract-plugin
export var background = "bl_y";
export var backgroundContainer = "bl_fC";
export var buttons = "bl_cr";
export var container = "bl_b";
export var middleWave = "bl_cT";
export var section = "bl_d";
export var text = "bl_b0";
export var textContainer = "bl_cW";
export var title = "bl_h";